<template>
<!-- 复用组件 itemTable 的弹出窗 编辑 新增都是它 -->
<div>
  <el-dialog :title="temp.name" :visible.sync="dialog.dialogFormVisible" width="35%" append-to-body >
    <el-form :model="temp" label-position="right" label-width="100px" class="dialog-form" :rules="rules" ref="form">
      <el-form-item label="虚拟表" prop="vtId">
        <el-select v-model="temp.vtId" @change="getVTName" filterable>
          <el-option v-for="(item, index) of API.VTList" :key="index" :value="item.id.id" :label="API.VTTextMap.get(item.id.id)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="输入值" prop="value">
        <el-input-number v-model="temp.value" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="选择时间类型">
        <el-select v-model="temp.type">
          <el-option label="年" value="year"></el-option>
          <el-option label="月" value="month"></el-option>
          <!-- <el-option label="周" value="week"></el-option> -->
          <el-option label="日" value="date"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择时间" prop="time">
        <el-date-picker :clearable="false" :type="temp.type" v-model="origTime" @change="getTime" v-if="temp.type !== 'week'" :picker-options="pickerOptions"></el-date-picker>
        <el-date-picker :clearable="false" :type="temp.type" v-model="origTime" @change="getTime" v-else format="yyyy 第 WW 周" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="公式类型">
        <el-select v-model="temp.virtualType">
          <el-option label="计算值" value="CALCULATION_VALUE"></el-option>
          <el-option label="输入值" value="INPUT_VALUE"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" plain @click="saveInfo">保存</el-button>
        <!-- <el-button type="primary" plain @click="$emit('Save')">保存</el-button> -->
        <el-button @click="dialog.dialogFormVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
// const moment = require('moment')
const moment = require('moment-timezone')
moment.tz.setDefault(moment.tz.guess())
export default {
  name: 'dialogs',
  props: [
    'temp',
    'dialog',
    'API',
    'titleVerify',
    'groupOptions'
  ],
  data () {
    const validatePrice = (rule, value, callback) => {
      const sValue = String(value)
      if (sValue.indexOf('.') > -1 && sValue.split('.')[1].length > 2) {
        callback(new Error('精确到小数点后2位'))
      } else {
        callback()
      }
    }
    return {
      origTime: null,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      rules: {
        vtId: { required: true, message: '请选择虚拟表', trigger: 'change' },
        time: { required: true, message: '请选择时间', trigger: 'blur' },
        unit: { required: true, message: '请输入公式单位 ', trigger: 'blur' },
        series: { required: true, message: '请输入公式编号', trigger: 'blur' },
        value: [
          { required: true, message: '请输入指标值', trigger: 'blur' },
          { validator: validatePrice, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    getTime () {
      // this.temp.time = moment(this.origTime).add(1, this.temp.type + 's').subtract(1, 's').valueOf()
      // console.log(this.origTime, moment(this.origTime).valueOf(), moment(this.origTime).add(moment(this.origTime).utcOffset(), 'm').valueOf())
      switch (this.temp.type) {
        case 'month':
        case 'year':
        case 'week':
          this.temp.time = moment(this.origTime).endOf(this.temp.type).valueOf()
          console.log(this.temp.time)
          break
        case 'date':
          console.log('not')
          this.temp.time = moment(this.origTime).startOf(this.temp.type).valueOf()
          break
        default:
          break
      }
      // this.temp.time = moment(this.origTime).startOf(this.temp.type).valueOf()
    },
    saveInfo () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialog.dialogFormVisible = false
          this.$emit('Save')
        } else {
          this.$message('请完善表单')
        }
      })
    },
    getVTName () {
      this.temp.vtName = this.API.VTTextMap.get(this.temp.vtId)
    }
  },
  created () {
    if (!this.temp.type) {
      this.temp.type = 'year'
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  .el-form {
    max-height: 600px;
    overflow-y: auto;
  }
}
.dialog-form {
  padding-right: 10px;
}
</style>
